export const inlineTemplate = `
  <div class="ct-w-inline">
    <div class="ct-w-inline-body">
      <label class="ct-w-inline-control">
        <input class="ct-w-ack-input" type="checkbox" />
        <span class="ct-w-checkbox-box" aria-hidden="true">
          <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true" focusable="false" fill="none">
            <path d="M3 8l3 3 7-7" stroke="#9e77ed" stroke-width="var(--ct-w-inline-checkbox-check-width, 1.6)" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </span>
      </label>
      <div class="ct-w-inline-content">
        <div class="ct-w-scroll-content"></div>
      </div>
    </div>
  </div>
`;
